import { IconButton, Tooltip } from '@chakra-ui/react';
import React from 'react';
import { faMagnet } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import SparkelIcon from 'src/components/common/icon/SparkelIcon';
import { useLocalStorage } from 'src/hooks/local-storage';
import { SNAPPING_LOCAL_STORAGE_KEY } from 'src/components/viewers/SheetsViewerV2/utils/snapping';

export default function SnappingButton(): React.ReactElement {
  const { t } = useTranslation('project');
  const [isSnappingEnabled, setIsSnappingEnabled] = useLocalStorage(
    SNAPPING_LOCAL_STORAGE_KEY,
    true
  );

  const activeIconColor: [string, string] = ['teal.500', 'teal.200'];

  return (
    <Tooltip label={t('viewer-interactions.snapping-toggle')}>
      <IconButton
        aria-label={t('viewer-interactions.snapping-toggle')}
        icon={
          <SparkelIcon
            icon={faMagnet}
            color={isSnappingEnabled ? activeIconColor : undefined}
          />
        }
        isRound
        isActive={isSnappingEnabled}
        colorScheme={isSnappingEnabled ? 'teal' : 'gray'}
        variant={isSnappingEnabled ? 'toggle' : 'solid-no-transparent'}
        size="xs"
        onClick={() => setIsSnappingEnabled((v: boolean) => !v)}
      />
    </Tooltip>
  );
}
